import axios from 'axios';

export default function errorStatusIs(err: unknown, status: number): boolean {
  return axios.isAxiosError(err) && err.response?.status == status;
}
